export const userRoles = {
	SUPER_ADMIN: "Super Admin",
	COUNSEL: "Counsel",
	USER: "User",
	OCC: "Office of the Court Clerk",
	BCC: "Branch of the Court Clerk",
	JUDGE: "Judge",
	DASHBOARD: "Dashboard User",
	STENOGRAPHER: "Stenographer",
	SHERIFF: "Sheriff",
};
